import React from 'react'
import cx from 'classnames'

import { Button } from 'components/_new/controls'
import type { ButtonProps } from 'components/_new/controls'

import s from './Buttons.scss'


export type ButtonsProps = {
  leftButton?: Partial<ButtonProps> & { component?: any }
  rightButton?: Partial<ButtonProps>
}

const Buttons: React.FunctionComponent<ButtonsProps> = ({ leftButton, rightButton }) => (
  <div className={s.buttons}>
    {
      Boolean(leftButton) && (
        React.createElement(leftButton.component || Button, {
          size: 'md',
          color: 'brand',
          dataTestId: 'dialogModalFirstButton',
          ...leftButton,
          className: cx(s.button, leftButton.className),
          component: undefined,
        })
      )
    }
    {
      Boolean(rightButton) && (
        <Button
          size="md"
          color="brand"
          dataTestId="dialogModalSecondButton"
          {...rightButton}
          className={cx(s.button, rightButton.className)}
        />
      )
    }
  </div>
)


export default Buttons
